import React from 'react';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { formatDate } from '../../utils/inseeCodeMappings';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface ImportFile {
  id: number;
  originalFilename: string;
  createdAt: string;
  status: string;
}

interface AdminSectionProps {
  createdAt: string;
  importFile: ImportFile | null;
  isLoading: boolean;
}

const AdminSection: React.FC<AdminSectionProps> = ({
  createdAt,
  importFile,
  isLoading
}) => {
  return (
    <div className="bg-white shadow rounded-lg overflow-hidden border border-gray-200">
      <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b border-gray-200">
        <div className="flex items-center">
          <div className="bg-gray-100 rounded-full p-2 mr-3">
            <ClipboardDocumentIcon className="h-6 w-6 text-gray-600" />
          </div>
          <h3 className="text-lg font-medium leading-6 text-gray-900">
            Informations d'import
          </h3>
        </div>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">
          Métadonnées du système
        </p>
      </div>

      <div className="p-6">
        {isLoading ? (
          <div className="space-y-4">
            <Skeleton height={24} width="50%" />
            <Skeleton count={4} />
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-y-6">
            <div>
              <h4 className="text-sm font-medium text-gray-500">Date d'ajout</h4>
              <p className="mt-1 text-sm text-gray-900">{formatDate(createdAt)}</p>
            </div>
            
            <div>
              <h4 className="text-sm font-medium text-gray-500">Fichier d'origine</h4>
              <p className="mt-1 text-sm text-gray-900">
                {importFile ? importFile.originalFilename : '-'}
              </p>
            </div>
            
            <div>
              <h4 className="text-sm font-medium text-gray-500">Status du fichier</h4>
              <p className="mt-1">
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  importFile?.status === 'completed' 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-yellow-100 text-yellow-800'
                }`}>
                  {importFile?.status === 'completed' ? 'Traité' : 'En cours de traitement'}
                </span>
              </p>
            </div>
            
            <div>
              <h4 className="text-sm font-medium text-gray-500">Date d'import</h4>
              <p className="mt-1 text-sm text-gray-900">
                {importFile ? formatDate(importFile.createdAt) : '-'}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminSection; 